import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/**
 * Placeholder block for content that is still loading. Hidden from assistive
 * tech: a screen reader should hear the region's own loading message once, not
 * a dozen empty boxes.
 */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden
      className={cn('animate-pulse rounded-md bg-white/[0.06]', className)}
      {...props}
    />
  );
}
